/* eslint-disable react/prop-types */
import { cloneElement } from 'react';
import uniqid from 'uniqid';

const passProps = (
  element,
  { propsToPass = {}, keyPrefix = 'default-key-', key },
) => {
  if (!element) {
    return element;
  }

  const keyToUse = key || uniqid(keyPrefix);

  if (Array.isArray(element)) {
    return element.map((Element) =>
      cloneElement(Element, { key: keyToUse, ...propsToPass }),
    );
  }

  return cloneElement(element, propsToPass);
};

export default passProps;
